import type { Field } from '@pbt/pbt-ui-components'

import type { RetailOrderLineItem } from '~/api/graphql/generated/types'
import type { InvoiceLineItem } from '~/types'

import ChargeDetailsCurrencyField from './ChargeDetailsCurrencyField'

export interface ChargeFieldSellPriceProps {
  className?: string
  inputClassName?: string
  item: InvoiceLineItem | RetailOrderLineItem
  sellPriceField: Field
}

const ChargeFieldSellPrice = ({
  className: classNameProp,
  inputClassName,
  item,
  sellPriceField,
}: ChargeFieldSellPriceProps) => (
  <ChargeDetailsCurrencyField
    disabled
    className={classNameProp}
    field={sellPriceField}
    inputClassName={inputClassName}
    item={item}
  />
)

export default ChargeFieldSellPrice
